function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrizeCosm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#3fd2c7",
      fillOpacity: 1
    },
    d: "M 49.882812 51.941406 C 51.382812 49.4375 53.585938 48.152344 56.507812 48.117188 C 59.429688 48.085938 60.90625 46.597656 60.953125 43.667969 C 60.992188 40.753906 62.261719 38.550781 64.769531 37.058594 C 67.277344 35.558594 67.824219 33.542969 66.394531 30.992188 C 64.96875 28.445312 64.96875 25.898438 66.394531 23.347656 C 67.824219 20.800781 67.28125 18.789062 64.769531 17.292969 C 62.261719 15.789062 60.992188 13.589844 60.953125 10.660156 C 60.90625 7.746094 59.429688 6.257812 56.507812 6.222656 C 53.585938 6.183594 51.382812 4.90625 49.882812 2.402344 C 48.386719 -0.109375 46.371094 -0.652344 43.824219 0.777344 C 41.28125 2.199219 38.726562 2.199219 36.183594 0.777344 C 33.632812 -0.648438 31.617188 -0.109375 30.117188 2.402344 C 28.625 4.910156 26.417969 6.1875 23.5 6.222656 C 20.582031 6.257812 19.101562 7.746094 19.0625 10.660156 C 19.011719 13.589844 17.742188 15.785156 15.238281 17.292969 C 12.726562 18.789062 12.175781 20.800781 13.613281 23.347656 C 15.042969 25.898438 15.042969 28.445312 13.613281 30.992188 C 12.175781 33.542969 12.722656 35.5625 15.238281 37.058594 C 17.742188 38.550781 19.015625 40.753906 19.0625 43.667969 C 19.101562 46.59375 20.582031 48.085938 23.5 48.117188 C 26.421875 48.152344 28.625 49.4375 30.121094 51.941406 C 31.621094 54.453125 33.636719 54.996094 36.183594 53.558594 C 38.726562 52.148438 41.28125 52.148438 43.824219 53.558594 C 46.371094 54.992188 48.390625 54.453125 49.882812 51.941406 Z M 40.011719 43.15625 C 31.175781 43.15625 24.019531 36 24.019531 27.167969 C 24.019531 18.339844 31.175781 11.179688 40.011719 11.179688 C 48.835938 11.179688 55.996094 18.339844 55.996094 27.167969 C 55.996094 36 48.835938 43.15625 40.011719 43.15625 Z M 40.011719 43.15625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#3fd2c7",
      fillOpacity: 1
    },
    d: "M 23.242188 50.460938 C 20.167969 50.460938 19.757812 49.03125 19.757812 49.03125 L 7.761719 72.617188 L 17.382812 71.535156 L 22.703125 79.542969 C 22.703125 79.542969 33.785156 56.414062 33.785156 56.566406 C 28.042969 56.421875 30.328125 50.617188 23.242188 50.460938 Z M 23.242188 50.460938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#3fd2c7",
      fillOpacity: 1
    },
    d: "M 60.089844 49.957031 C 51.324219 50.875 53.109375 53.050781 51.101562 54.738281 C 48.796875 57.199219 45.914062 56.71875 45.914062 56.71875 L 59.449219 80 L 62.777344 71.378906 L 72.238281 72.613281 Z M 60.089844 49.957031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#3fd2c7",
      fillOpacity: 1
    },
    d: "M 43.347656 23.640625 L 40.003906 16.863281 L 36.652344 23.640625 L 29.164062 24.734375 L 34.578125 30.011719 L 33.300781 37.476562 L 40.003906 33.957031 L 46.707031 37.476562 L 45.429688 30.011719 L 50.84375 24.734375 Z M 43.347656 23.640625 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrizeCosm);
export default __webpack_public_path__ + "static/media/prize_cosm.0d4e136983fec340d008411a2e7bac21.svg";
export { ForwardRef as ReactComponent };